import RCPROConseil from "./RCPROQuestionsParSecteur/RCPROConseil";
import RCPROInformatique from "./RCPROQuestionsParSecteur/RCPROInformatique";
import RCPROAutreCommerce from "./RCPROQuestionsParSecteur/RCPROAutreCommerce";
import RCPROAutreService from "./RCPROQuestionsParSecteur/RCPROAutreService";
import RCPROMarketing from "./RCPROQuestionsParSecteur/RCPROMarketing";
import RCPROEducation from "./RCPROQuestionsParSecteur/RCPROEducation";
import RCPRORestauration from "./RCPROQuestionsParSecteur/RCPRORestauration";
import RCPROCommercesAlimentaires from "./RCPROQuestionsParSecteur/RCPROCommercesAlimentaires";
import RCPROHabillement from "./RCPROQuestionsParSecteur/RCPROHabillement";
import RCPROHygiene from "./RCPROQuestionsParSecteur/RCPROHygiene";
import RCPROCulture from "./RCPROQuestionsParSecteur/RCPROCulture";
import RCPRODroit from "./RCPROQuestionsParSecteur/RCPRODroit";
import RCPROSecurite from "./RCPROQuestionsParSecteur/RCPROSecurite";
import RCPRODiversBureau from "./RCPROQuestionsParSecteur/RCPRODiversBureau";
import RCPROServiceEntreprise from "./RCPROQuestionsParSecteur/RCPROServiceEntreprise";
import RCPROServicePersonne from "./RCPROQuestionsParSecteur/RCPROServicePersonne";
import RCPROSante from "./RCPROQuestionsParSecteur/RCPROSante";
import RCPROTitreSecteur from "./RCPROTitreSecteur";
import useActivitiesOfSector from "./useActivitiesOfSector";

const RCPROSpecificQuestions = ({ company, categoryId }) => {
  const categoryRef = {
    1: { component: RCPROConseil, title: "Conseil", icon: "fa-briefcase" },
    2: {
      component: RCPROInformatique,
      title: "Informatique",
      icon: "fa-laptop",
    },
    12: {
      component: RCPROMarketing,
      title: "Marketing / Communication / Médias",
      icon: "fa-bullhorn",
    },
    18: {
      component: RCPROEducation,
      title: "Éducation & Formation",
      icon: "fa-graduation-cap",
    },
    19: {
      component: RCPRORestauration,
      title: "Restauration",
      icon: "fa-utensils",
    },
    20: {
      component: RCPROCommercesAlimentaires,
      title: "Commerces Alimentaires",
      icon: "fa-utensils",
    },
    21: {
      component: RCPROHabillement,
      title: "Habillement & Accessoires",
      icon: "fa-tshirt",
    },
    22: { component: RCPROSante, title: "Santé", icon: "fa-heartbeat" },
    29: { component: RCPROHygiene, title: "Hygiène / Beauté", icon: "fa-spa" },
    32: {
      component: RCPROCulture,
      title: "Culture / Art / Tourisme / Loisirs / Sport",
      icon: "fa-utensils",
    },
    37: {
      component: RCPRODroit,
      title: "Métiers du Droit",
      icon: "fa-graduation-cap",
    },
    38: {
      component: RCPROSecurite,
      title: "Métiers de la Sécurité",
      icon: "fa-shield-alt",
    },
    39: {
      component: RCPRODiversBureau,
      title: "Métiers Divers de Bureau",
      icon: "fa-briefcase",
    },
    40: {
      component: RCPROServiceEntreprise,
      title: "Services aux Entreprise",
      icon: "fa-briefcase",
    },
    41: {
      component: RCPROServicePersonne,
      title: "Services à la Personne",
      icon: "fa-user",
    },
    43: {
      component: RCPROAutreCommerce,
      title: "Autres Commerces",
      icon: "fa-briefcase",
    },
    44: {
      component: RCPROAutreService,
      title: "Autres Services",
      icon: "fa-briefcase",
    },
  };

  const { activitiesFiltered } = useActivitiesOfSector(categoryId);
  const selectedActivities = company.RCPRO.activitesPro;

  const selectedActivitiesData = activitiesFiltered.filter((a) =>
    selectedActivities.find((s) => s + "" == a.id + "")
  );

  const ComponentName = categoryRef[categoryId].component;

  return (
    <div>
      <RCPROTitreSecteur
        title={categoryRef[categoryId].title}
        icon={categoryRef[categoryId].icon}
        description={selectedActivitiesData.map((a) => a.name).join(", ")}
      />
      <ComponentName company={company} title={categoryRef[categoryId].title} />
    </div>
  );
};

export default RCPROSpecificQuestions;
